module.exports = __webpack_public_path__ + "img/red.e3517607.svg";